@if (viewState == 'initial' ) {
<div class="alert alert-info m-5">
  <h5 i18n="@@browserRecordingPermission">
    Erteilen Sie bitte in dem Browser, in dem Ihnen der QR-Code angezeigt wurde, die Erlaubnis zur Aufnahme.
  </h5>
</div>
}
@if (viewState == 'forbidden' ) {
<div class="alert alert-danger m-5">
  <h5 i18n="@@browserRecordingPermissionDenied">
    Sie haben der Aufnahme nicht zugestimmt, diese Seite kann geschlossen werden.
  </h5>
</div>
}
<div
  style="position: fixed; bottom: 5px; left: 50%; transform: translateX(-50%); display: flex; gap: 16px; z-index: 9999;"
>
  <a
    href="https://www.profil-m.de/ac-suite-datenschutz/"
    target="_blank"
    rel="noopener noreferrer"
    style="color: #333; font-size: 12px; text-decoration: none;"
    i18n="@@linkPrivacyPolicy"
  >Datenschutzhinweise</a>
  <a
    href="https://www.profil-m.de/impressum/"
    target="_blank"
    rel="noopener noreferrer"
    style="color: #333; font-size: 12px; text-decoration: none;"
    i18n="@@linkImprint"
  >Impressum</a>
</div>